<template>
  <svg
    viewBox="0 0 96 96"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="m92.22 48.67c-1.63-.68-4.09-.6-6.55-.21a38.07 38.07 0 1 0 .11 10.15l2.22-.56c2-.46 5.42.21 7-1.29 2.32-2.13-.42-7.11-2.78-8.09zm-2.88 7.23c-.85.14-1.78.46-2.64.68l-9.7 2.5-23.9 6.18c-3.54.91-2.63 2.84-4.62 6.08-3 4.84-9.33 6.3-14.61 4.91a16.08 16.08 0 0 1 -6.46-3.25c-.58-.5-1.82-1.44-2.05-2.23-1-3.56 2.63-4.51 4.78-5.39 1-.42.58-2.11-.47-1.69-4.82 2-9.13 4.95-4.36 9.82 5 5.16 14.14 6.61 20.39 3a12.94 12.94 0 0 0 5.24-6.12c1-2.17.3-2.38 2-3.25 4-2 9.79-2.53 14.14-3.65l14.51-3.75a34.11 34.11 0 1 1 .17-10.43c-1 .27-1.93.54-2.67.78-9.35 3-18.44 7.37-27.57 11-1 .41-.58 2.11.47 1.69l19.7-7.88c2.6-1 5.2-2.27 7.87-3.14 3-1 9-2.62 11.92-1.28.79.36 2.77 2.45 2.57 3.66-.35 1.99-3.34 1.54-4.71 1.76z"
      fill="#4f2b1b"
    />
    <circle
      cx="31.94"
      cy="57.29"
      fill="#85c441"
      r=".97"
    />
    <circle
      cx="38.86"
      cy="53.05"
      fill="#85c441"
      r=".97"
    />
    <circle
      cx="45.33"
      cy="48.72"
      fill="#85c441"
      r=".97"
    />
    <circle
      cx="45.34"
      cy="55.73"
      fill="#85c441"
      r=".97"
    />
    <circle
      cx="37.79"
      cy="60.78"
      fill="#85c441"
      r=".97"
    />
    <circle
      cx="45.35"
      cy="62.75"
      fill="#85c441"
      r=".97"
    />
    <path
      d="m53.44 52.79c-1-5.53-5.62-11.33-11.29-12.68a6.48 6.48 0 0 0 1.66-5.22 1 1 0 0 0 -1.43-.58c-2.4 1.11-6.21 4.62-9 4-1.22-.25-1.74 1.62-.52 1.88 3.13.65 6.26-1.84 9-3.48-.48 2.66-3.91 4-5.67 5.44-.5.41-.85.42-1.07 1.08a.94.94 0 0 0 .25.94c1.12 1.1 3.25 1.58 5 2a5.87 5.87 0 0 1 -7.13 1 1 1 0 0 0 -1.43.58c-1.34 3.28-3.59 5-6.63 4.78a13.21 13.21 0 0 0 1.85-3.71 1 1 0 0 0 -.68-1.19 5.1 5.1 0 0 1 -3.39-2c3.47-.37 9.26-1.2 8.87-4.88-.34-3.26-5.73-5.4-8.15-6.65-1.11-.57-2.09 1.1-1 1.68 2 1 4.64 2.1 6.15 3.79 3.14 3.52-5.7 4.06-7.62 4.29a1 1 0 0 0 -.84 1.47c1.29 2.07 2.25 3.41 4.41 4a3.9 3.9 0 0 1 -2.43 2.93 1 1 0 0 0 .23 1.78 10.36 10.36 0 0 0 2.39.46c1 9.36 9.2 15 18.28 14.73 4.82-.15 6.3-1.59 8.47-6a16.76 16.76 0 0 0 1.72-10.44zm-4.44 11.65c-3 3.56-7.55 3.42-11.62 2.27a14.46 14.46 0 0 1 -10.38-12.21c2.74-.43 4.88-2.27 6.3-5.13 3.75 1.44 7.2.21 9.7-3.12.41-.54 0-1.24-.58-1.43a18.72 18.72 0 0 0 -3.86-1.32c-.39 0-.57-.08-.67-.09.74-.6 2-1.1 2.74-1.72a.83.83 0 0 0 .37.15c4.93.88 9 5.65 10.29 10.33 1.03 3.83.31 9.16-2.29 12.27z"
      fill="#85c441"
    />
    <g fill="#4f2b1b">
      <path
        d="m76.65 57.66v-.11a.2.2 0 0 0 -.08-.08c-.23 0-.09.1-.29.12s-.05 1-.47-.25a3.21 3.21 0 0 1 0-1.57.12.12 0 0 0 -.11-.14.79.79 0 0 0 -.87.33c-.11.17-.07.27-.12.47a10.93 10.93 0 0 1 -.32 1.06c0-.6 0-1.4-.6-1.46s-.92.86-1.14 1.3c0 .11-.11.22-.17.33a1.12 1.12 0 0 0 .14-.73c-.07-.24 0-.24-.25-.37-.73-.32-.8.75-.8 1.16s-.28 2.18.77 2c.5-.09.46-.82.56-1.25a7.4 7.4 0 0 0 .38-1.35c.22.27 0 1.12.23 1.49s.72.59 1 .18.11-.64.22-1 .05-.19.31.15a1.37 1.37 0 0 0 .39.37.76.76 0 0 0 1.22-.62s0-.02 0-.03z"
      />
      <path
        d="m78.73 56.79a.1.1 0 0 0 -.15 0c-.17.27-.41.51-.5.11a3.63 3.63 0 0 1 0-1c0-.23.12-.82 0-1s-.34-.12-.54-.06c-.39.13-.39.38-.44.77-.09.74-.17 2.1.77 2.39a.82.82 0 0 0 .44 0s0 0 .06 0a.77.77 0 0 0 .37-.48s0 0 0 0c.04-.3.26-.6-.01-.73z"
      />
      <path
        d="m77.43 54.3a1.88 1.88 0 0 0 .24 0 .12.12 0 0 0 .14 0c.15-.12.28 0 .41-.22a1.47 1.47 0 0 0 .14-.85.08.08 0 0 0 0 0s0 0 0 0a.52.52 0 0 0 -.36-.23 1.57 1.57 0 0 0 -.53.17c-.15.11-.15.45-.19.61a.55.55 0 0 0 0 .42.1.1 0 0 0 .15.1z"
      />
      <path
        d="m81.9 55.57a.11.11 0 0 0 -.22 0 .36.36 0 0 1 -.3.49c-.21-.05-.33-.15-.36-.32s.29-.45.35-.55a4.88 4.88 0 0 0 .56-1.09s0 0 0 0a1.11 1.11 0 0 0 -.05-.25.11.11 0 0 0 -.08-.08c-.68-.18-1.15.77-1.45 1.34-.27-.27-.7-.61-.91-.19a.11.11 0 0 0 0 .12c.11.16.53.55.55.75a4.62 4.62 0 0 1 -.25.6c-.13.36-.21.64 0 .94.07.08.19 0 .2-.08a.12.12 0 0 0 .18 0c.09-.17.29-.74.48-.76a7.65 7.65 0 0 1 .72.34c.26.08.59.12.68-.21a2.48 2.48 0 0 0 -.1-1.05z"
      />
      <path
        d="m84.63 55.38a.12.12 0 0 0 0-.13c0-.13-.15-.2-.21-.09-.2.33-.47.48-.5 0a8.7 8.7 0 0 1 0-1 2 2 0 0 0 -.06-1 .13.13 0 0 0 -.16 0c-.21.12-.4 0-.6.18s-.14.44-.16.63a2.59 2.59 0 0 0 .19 1.78 1.21 1.21 0 0 0 1 .62 0 0 0 0 0 0 0c.12-.09.22-.2.34-.31a.14.14 0 0 0 0-.14 2.47 2.47 0 0 1 .16-.54z"
      />
      <path
        d="m83.1 52.39s0 0 0 .08v.07a.13.13 0 0 0 .13.06.29.29 0 0 1 .2 0 .1.1 0 0 0 .16 0c.3-.25.29 0 .45-.37a1.5 1.5 0 0 0 .08-.7s0 0 0 0a.08.08 0 0 0 0 0c-.1 0 0 0 0 0s-.07-.12-.14-.11c-.61.11-.66.46-.81 1a.12.12 0 0 0 -.07-.03z"
      />
      <path
        d="m87.83 53.65a.11.11 0 0 0 -.19-.08c-.25.23-.36.56-.59.79-.65.63-.78 0-.81-.64a1.64 1.64 0 0 1 .93-1.46.12.12 0 0 0 0-.2.62.62 0 0 0 -.48-.06c-.06 0-.43.15-.38.17a4.47 4.47 0 0 1 .1-.85c0-.34 0-.48-.39-.62a.12.12 0 0 0 -.14.08 9.77 9.77 0 0 1 -.62 1.87c-.16.23-.28.16-.22.49a.13.13 0 0 0 .11.09c.33 0 .12.39.13.64a2.39 2.39 0 0 0 .1.71 1.38 1.38 0 0 0 .72.83c.9.38 1.42-.51 1.68-1.23a1.42 1.42 0 0 0 .05-.53z"
      />
      <path d="m82.63 55.66s0 0 0 0c-.46.24-.27 1 .27.83s.25-.88-.27-.83z" />
    </g>
  </svg>
</template>
